import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"> {/* py-12 → py-8 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6"> {/* gap-8 → gap-6 */}
          {/* 회사 정보 */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-2"> {/* mb-4 → mb-2 */}
              <h2 className="text-white text-lg font-bold">FairNex</h2> {/* text-xl → text-lg */}              
            </div>
            <p className="text-sm mb-2"> {/* mb-4 → mb-2 */}
              FairNex - AI 비서와 함께 더 스마트하고 더 효율적으로 업무를 자동화하는 AI 에이전트 서비스
            </p>
            <div className="flex space-x-4">
              <a 
                href="mailto:kiki57461@gmail.com" 
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                kiki57461@gmail.com
              </a>
            </div>
          </div>

          {/* 빠른 링크 */}
          <div>
            <h3 className="text-white text-sm font-semibold mb-2"> {/* mb-4 → mb-2, 텍스트 크기 조정 */}
              바로가기
            </h3>
            <ul className="space-y-1 text-sm"> {/* space-y-2 → space-y-1 */}
              <li>
                <Link 
                  to="/about" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  서비스 소개
                </Link>
              </li>
              <li>
                <Link 
                  to="/service" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  서비스 안내
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  문의하기
                </Link>
              </li>
            </ul>
          </div>

          {/* 법적 링크 */}
          <div>
            <h3 className="text-white text-sm font-semibold mb-2"> {/* mb-4 → mb-2, 텍스트 크기 조정 */}
              약관 및 정책
            </h3>
            <ul className="space-y-1 text-sm"> {/* space-y-2 → space-y-1 */}
              <li>
                <Link 
                  to="/terms" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  이용약관
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  개인정보처리방침
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-800 text-xs text-gray-400"> {/* mt-8 pt-8 → mt-6 pt-6, text-sm → text-xs */}
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>© 2025 FairNex. All rights reserved.</p>
            <div className="mt-2 md:mt-0 flex space-x-4"> {/* mt-4 → mt-2 */}
              <Link 
                to="/terms" 
                className="hover:text-white transition-colors"
              >
                Terms
              </Link>
              <span>·</span>
              <Link 
                to="/privacy" 
                className="hover:text-white transition-colors"
              >
                Privacy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;